function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 3.038V8a2 2 0 002 2h8a2 2 0 002-2V2a2 2 0 00-2-2H2a2 2 0 00-2 2v1.038zM2 1h8a1 1 0 011 1v.74L6 5.432 1 2.74V2a1 1 0 011-1zM1 3.876L5.763 6.44a.5.5 0 00.474 0L11 3.876V8a1 1 0 01-1 1H2a1 1 0 01-1-1V3.876z",
  fill: "#484644"
});

function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgEmail;